import BigNumber from 'bignumber.js';
import { formatUnits, parseUnits } from 'viem';

import { BLOCKS_PER_SECOND } from 'modules/api/const';

const ETHERS_UNIT = 18;

export function convertFromWei(value: bigint, unit: number = ETHERS_UNIT) {
  return new BigNumber(formatUnits(value, unit));
}

export function convertToWei(value: BigNumber, unit: number = ETHERS_UNIT) {
  return parseUnits(value.toString(), unit);
}

export const mapDataToUndefinedIfSkip = <
  T extends { data?: unknown; isUninitialized?: boolean },
>(
  result: T,
): T => (result.isUninitialized ? { ...result, data: undefined } : result);

export function convertBlocksToSeconds(blocks: number): number {
  return new BigNumber(blocks).div(BLOCKS_PER_SECOND).integerValue().toNumber();
}
